// The gateway registry, frontend side. GENERATED DATA + hand-written helpers.
//
// gatewayRegistry.generated.json is produced by the backend's
// app/bin/scripts/gatewayRegistry/export.js and is byte-identical to the fixture that repo
// commits. DO NOT HAND-EDIT IT — regenerate. A backend test fails if the fixture drifts from
// app/config/gateways.js, and src/constants/__tests__/gatewayRegistry.test.js fails if the
// derived lists here drift from it.
//
// STATIC facts only. Credential presence (`configured`) and the RESOLVED Mint sub-processor list
// are per-environment and arrive over the wire — on the /bankaccounts/users/:id and
// /cards/users/:id rows (`gatewayFlags`) and on /payments/:id/gateway-options. Never bake either
// into this file: stage holds Sola/LawPay keys production may not, and a baked flag would make
// this UI lie in at least one environment.
import registry from './gatewayRegistry.generated.json'

export const GATEWAY_ENTRIES = registry.gateways
export const GATEWAY_IDS = GATEWAY_ENTRIES.map((g) => g.id)

export const gatewayEntry = (id) => GATEWAY_ENTRIES.find((g) => g.id === id) || null

const idsWhere = (predicate) => GATEWAY_ENTRIES.filter(predicate).map((g) => g.id)

export const labelMap = () => Object.fromEntries(GATEWAY_ENTRIES.map((g) => [g.id, g.label]))
export const shortLabelMap = () => Object.fromEntries(GATEWAY_ENTRIES.map((g) => [g.id, g.shortLabel]))

export const achOnlyIds = () => idsWhere((g) => g.achOnly)

// The gateways whose availability depends on credentials, per rail — the exact key sets the
// backend emits in each row's `gatewayFlags` (services/billingAccount/gatewayFlags.js).
export const credentialGatedIds = (rail) => (rail === 'card'
  ? idsWhere((g) => g.card && !g.achOnly && !g.alwaysConfigured)
  : idsWhere((g) => g.ach && !g.alwaysConfigured))

// Gateway-picker values for a rail: canonical order, and immediately after a gateway that
// hasSubProcessors, its 'mint:<key>' composites for that rail in DECLARATION order. Identical
// rule to the backend's validatePaymentDefaults.expandWithMintComposites and to
// gatewayAvailability.buildChargeableOptions — one rule, three call sites, no drift.
//
// `mintComposites` is { ACH: string[], Card: string[] } of sub-processor KEYS. The Settings
// screen passes the DECLARED keys (the vocabulary a company may save, which is deliberately not
// filtered on whether MINT_PROCESSOR_*_ID is set — that is a runtime availability question the
// per-payment gateway-options endpoint answers).
const railValues = (rail, mintComposites, method) => idsWhere((g) => g[rail] && g.routable)
  .flatMap((id) => (gatewayEntry(id).hasSubProcessors
    ? [id, ...((mintComposites?.[method]) || []).map((key) => `mint:${key}`)]
    : [id]))

export const achGatewayValues = (mintComposites) => railValues('ach', mintComposites, 'ACH')
export const cardGatewayValues = (mintComposites) => railValues('card', mintComposites, 'Card')
